import { render, staticRenderFns } from "./PaginaNaoEncontradaView.vue?vue&type=template&id=e309bffe&scoped=true&"
import script from "./PaginaNaoEncontradaView.vue?vue&type=script&lang=js&"
export * from "./PaginaNaoEncontradaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e309bffe",
  null
  
)

export default component.exports